import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import {
  POLICYRISKITEM_INIT_LOADING,
  POLICYRISKITEM_INIT_SUCCESS,
  POLICYRISKITEM_INIT_FAIL,
  POLITEM_SAVE_LOADING,
  POLITEM_SAVE_SUCCESS,
  POLITEM_SAVE_FAIL,
  POLITEMSTATS_SAVE_LOADING,
  POLITEMSTATS_SAVE_SUCCESS,
  POLITEMSTATS_SAVE_FAIL,
  POLITEMUOM_SAVE_LOADING,
  POLITEMUOM_SAVE_SUCCESS,
  POLITEMUOM_SAVE_FAIL,
  POLSUBITEM_INIT_LOADING,
  POLSUBITEM_INIT_SUCCESS,
  POLSUBITEM_INIT_FAIL,
  POLSUBITEM_SAVE_LOADING,
  POLSUBITEM_SAVE_SUCCESS,
  POLSUBITEM_SAVE_FAIL,
  POLITEMBEN_SAVE_LOADING,
  POLITEMBEN_SAVE_SUCCESS,
  POLITEMBEN_SAVE_FAIL,
  POLICY_COVERAGE_DISCLDG_PD_GAP_CEDSI_AND_OUR_SHARE_SI } from '@/store/types'

export const item = {
  async policyRiskItemInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyRiskItem
    commit(POLICYRISKITEM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYRISKITEM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLICYRISKITEM_INIT_FAIL, extractMessages(error))
    }
  },
  async savePolItem ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.savePolItem
    if (apiUrl) {
      commit(POLITEM_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLITEM_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLITEM_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLITEM_SAVE_FAIL, generateManualSaveError(['Fail to save PolItem']))
        }
        return false
      }
    } else {
      commit(POLITEM_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolItemTxtRef ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.savePolItemTxtRef
    if (apiUrl) {
      commit(POLITEM_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLITEM_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLITEM_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLITEM_SAVE_FAIL, generateManualSaveError(['Fail to save PolItem']))
        }
        return false
      }
    } else {
      commit(POLITEM_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolItemEml({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.savePolItemEml
    if (apiUrl) {
      commit(POLITEM_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLITEM_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLITEM_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLITEM_SAVE_FAIL, generateManualSaveError(['Fail to save PolItem']))
        }
        return false
      }
    } else {
      commit(POLITEM_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolItemRecalcBen({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.savePolItemRecalcBen
    if (apiUrl) {
      commit(POLITEM_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLITEM_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLITEM_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLITEM_SAVE_FAIL, generateManualSaveError(['Fail to save PolItem']))
        }
        return false
      }
    } else {
      commit(POLITEM_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolItemStats ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.savePolItemStats
    if (apiUrl) {
      commit(POLITEMSTATS_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLITEMSTATS_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLITEMSTATS_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLITEMSTATS_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Item Statistics']))
        }
        return false
      }
    } else {
      commit(POLITEMSTATS_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolItemUOM ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.saveUOM
    if (apiUrl) {
      commit(POLITEMUOM_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLITEMUOM_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLITEMUOM_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLITEMUOM_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Item UOM']))
        }
        return false
      }
    } else {
      commit(POLITEMUOM_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async polSubItemInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policySubItem
    commit(POLSUBITEM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLSUBITEM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLSUBITEM_INIT_FAIL, extractMessages(error))
    }
  },
  async savePolSubItem ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policySubItemSettings.menu.saveSubItem
    if (apiUrl) {
      commit(POLSUBITEM_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLSUBITEM_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLSUBITEM_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLSUBITEM_SAVE_FAIL, generateManualSaveError(['Fail to save PolSubItem']))
        }
        return false
      }
    } else {
      commit(POLSUBITEM_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolItemBen ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.saveBen
    if (apiUrl) {
      commit(POLITEMBEN_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLITEMBEN_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLITEMBEN_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLITEMBEN_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Item Benefit']))
        }
        return false
      }
    } else {
      commit(POLITEMBEN_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async calcAndUpdatePRAndPM({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.calcAndUpdatePRAndPM
    if (apiUrl) {
      try {
        const expand = {
          polNo: formData.polNo,
          renCnt: formData.renCnt,
          endtCnt: formData.endtCnt,
          riskGrpNo: formData.riskGrpNo
        }

        let result = await http.post(apiUrl, expand)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICY_COVERAGE_DISCLDG_PD_GAP_CEDSI_AND_OUR_SHARE_SI, commitObject)
          return true
        }
      } catch (err) {
      }
      return false
    }
  },
  async calcAndUpdateSpecificPRAndPM({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskItemSettings.menu.calcAndUpdateSpecificPRAndPM
    if (apiUrl) {
      try {
        const expand = {
          polNo: formData.polNo,
          renCnt: formData.renCnt,
          endtCnt: formData.endtCnt,
          riskGrpNo: formData.riskGrpNo,
          riskNo: formData.riskNo
        }

        let result = await http.post(apiUrl, expand)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICY_COVERAGE_DISCLDG_PD_GAP_CEDSI_AND_OUR_SHARE_SI, commitObject)
          return true
        }
      } catch (err) {
      }
      return false
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []
  let types = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
        types.push(err.type)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages,
    types: types
  }
}
